<template>
	<div class="formBox">
		<!-- 修正表单绑定和提交事件 -->
		<div class="print_3G_Je">
			<div class="content print_contents" v-if="table_list">
				<a-form :validateOnRuleChange='true' :form="form" @submit="handleSubmit">
					<div id="printTest" class="parser" ref="printBoxInner_3Vadp">
						<div class="printWraper_1kuG2">
							<div class="wraper_3ul6r"
								style="margin: 0px 40px 20px 40px; min-height: auto; justify-content: flex-start;">
							</div>

							<h4 class="title_3Yf8c">
								{{ title }}
							</h4>
							<div class="printBorder_3MGfU">

								<div v-if="type==1">


									<ExcelVue :add_flag='add_flag' @add_flag_get='add_flag_get'
										@goods_name_change='goods_name_change' :can_change='can_change' ref='ExcelVues'
										:template_id='template_id' :is_limit='is_limit' :table_list="table_list"
										:width="width" :scale="scale" :form="form"></ExcelVue>

								</div>
								<div v-else>
									<exccelInfo ref='ExcelVuesInfo' :template_id='template_id' :table_list="table_list"
										:width="width" :scale="scale" :form="form"></exccelInfo>



								</div>
								<!-- exccelInfo -->
							</div>
						</div>
					</div>

					<!-- 修正提交按钮，添加 type="submit" -->
					<div class='submit_btn_box'>

						<a-button class='btn' @click="back">
							返回
						</a-button>
						<a-button v-if='examine==1' v-print='printObj' class='btn' type="primary">
							打印
						</a-button>


						<a-button :loading="loading" class='btn' v-if='type==1' @click="handleSave">
							暂存
						</a-button>



						<a-button :loading="loading2" type="primary" class='btn' v-if='type==1' html-type="submit">
							提交
						</a-button>
						<a-button class='btn' v-if='type==1' @click='clearForm'>
							清除数据
						</a-button>

							<!-- <a-button :loading="loading" class='btn' @click="seve">
							保存模版
						</a-button> -->

					</div>
				</a-form>
			</div>

		</div>
		<a-modal v-model="modal2Visible" title="温馨提示" centered @ok="back">
			<p>{{tips}}</p>
		</a-modal>


		<a-modal v-model="clearVisible" title="温馨提示" centered @ok="clearback">
			<p>确认清除所有数据,清除后不可撤销！</p>
		</a-modal>


	</div>
</template>

<script>
	import ExcelVue from '../components/exccel.vue'
	import exccelInfo from '../components/exccelInfo.vue'
	import MineralWaterInspectionRecordForm from '../js/test.js'
	import moment from 'moment'
	import {
		getQualityRecordDetail,
		getFactorySelect,
		getMaterialSelect,
		saveQualityRecord,
		getGoodsSelect,
		saveTemplate,
		qualityGoodsSelect,
		getDensitySelect,
		getLineSelect,
		getGoodsTemplate
	} from "@/api/quality";
	export default {
		components: {
			ExcelVue,
			exccelInfo
		},
		data() {
			return {
				add_flag: 1,
				clearVisible: false,
				config: this.$config,
				tips: '',
				modal2Visible: false,
				// title: MineralWaterInspectionRecordForm.title,
				// table_list: MineralWaterInspectionRecordForm.PETBottleProcessInspectionRecordForm,
				// width: 3000,
				examine: 0,
				
				title: null,
				table_list: null,
				width: 1200,
				loading: false,
				loading2: false,

				is_limit: 0,
				// 正确创建表单实例
				form: this.$form.createForm(this),
				scale: 1,
				can_change: 0,
				showButton:false,
				 printObj: {
				        id: "printTest", //要打印的id名 无#号
				        extraCss: "", // 打印可引入外部的一个 css 文件
				        popTitle: "", //打印的页眉标题，默认浏览器标题 空字符串时显示undefined 使用html语言
				        extraHead: "", //最上方的头部文字，附加在head标签上的额外标签,使用逗号分隔
				        preview: "", // 是否启动预览模式，默认是false（开启预览模式，可以先预览后打印）
				        previewTitle: "", // 打印预览的标题（开启预览模式后出现）,
				        previewPrintBtnLabel: "", // 打印预览的标题的下方按钮文本，点击可进入打印（开启预览模式后出现）
				        zIndex: "", // 预览的窗口的z-index，默认是 20002（此值要高一些，这涉及到预览模式是否显示在最上面）
				        beforeOpenCallback(that) {
							document.title = that.new_title
						}, // 开启打印前的回调事件
				        openCallback(that) {
							document.title = that.new_title
						}, // 调用打印之后的回调事件
				        closeCallback() {
							document.title = "润田动销管理系统"
						}, //关闭打印的回调事件（无法确定点击的是确认还是取消）
				        url: "",
				        standard: "",
				      },
					  new_title:'',
			}
		},
		created() {
			this.type = this.$route.query.type
			this.id = this.$route.query.id
			this.template_id = this.$route.query.template_id
			this.p_type = this.$route.query.p_type
			this.examine = this.$route.query.examine=='true'?1:0
			this.getQualityRecordDetail()
			this.can_change = this.$route.query.can_change
			
		},
		
		  
		methods: {
			
			add_flag_get(e) {
				this.add_flag = e
			},
			clearback() {
				this.form.resetFields()
				this.table_list.forEach(item => {

					item.forEach(i => {
						if (i.fun) {
							i.fun = new Function('return ' + i.fun)();
						}
						if (i.type == 'table') {
							i.table_list.forEach(v => {
								v.forEach(d => {
									if (d.type != 'label') {
										d.value = null
									}

								})
							})
						}
						if (i.type == 'label') {
							if (i.field == "uid" && i.type == "label" && (i.value ==
									"检验员： " ||
									i.value == "检验员：")) {
								i.value = '检验员： '
							}
						} else if (i.type == 'select' && i.field == 'line_id') {
							i.before = null
							i.value = null
							i.style = 'display: flex;align-items: center;'
						} else {
							i.value = null
						}
					})
				})
				this.clearVisible = false

			},
			clearForm() {
				this.clearVisible = true


			},

			// 更改模版
			goods_name_change(e) {
				getGoodsTemplate({
					data: {
						"template_id": this.template_id, //模板id
						"goods_id": e //品项id
					}
				}).then(res => {
					if (res.data.list) {
						this.form.resetFields()
						this.template_id = res.data.list.template_id
						this.table_list = res.data.list.template_field
						this.$refs.ExcelVues.changeStyleClear(this.table_list)
						this.table_list.forEach(item => {

							item.forEach(i => {
								if (i.fun) {
									i.fun = new Function('return ' + i.fun)();
								}
								if (i.type == 'table') {
									i.table_list.forEach(v => {
										v.forEach(d => {
											if (d.fun) {
												d.fun = new Function('return ' +
													d.fun)();
											}
										})
									})
									if (i.is_add && i.is_add.rawData) {
										i.is_add.rawData.forEach(d => {
											if (d.fun) {
												d.fun = new Function('return ' + d.fun)
													();
											}
										})
									}

									if (i.is_add && i.is_add.fun) {
										i.is_add.fun = new Function('return ' + i.is_add.fun)();
									}

								}
								if (i.field == "factory_id" && i.type == "select") {
									getFactorySelect({
										data: {
											"type": "other" //类型 search搜索 other其它
										}
									}).then(res => {
										i.list = res.data.list
									})
								}
								if (i.field == "inspection_time" && i.type == "time") {
									i.value = i.value ? i.value : moment().format('YYYY-MM-DD')
								}
								if (i.field == "inspection_time" && i.type == "range_time") {
									i.value = i.value ? i.value.split('-') : null
								}
								if (i.field == "product_batch_time" && i.type == "range_time") {
									i.value = i.value ? i.value.split('-') : null
								}
								if (i.field == "product_batch_time" && i.type == "range_time") {
									i.value = i.value ? i.value.split('-') : null
								}
								if (i.field == "uid" && i.type == "label" && (i.value ==
										"检验员： " ||
										i.value == "检验员：")) {
									i.value = '检验员： ' + res.data.user.username
								}
								if (i.field == "uid" && i.type == "label" && i.value == "") {
									i.value = res.data.user.username
								}

								if (i.field == "line_id" && i.type == "select") {
									getLineSelect({
										data: {
											is_page: 0,
											template_id: this.template_id
										}
									}).then(res => {
										i.list = res.data.list
									})
								}
								if (i.field == "temperature" && i.type == "select") {
									getDensitySelect({
										data: {
											is_page: 0,
											source: "quality",
											template_id: this.template_id
										}
									}).then(res => {
										i.list = res.data.list
									})
								}
								if (i.field == "goods_name" && i.type == "select") {
									if (res.data.list.goods_select == 1) {
										getGoodsSelect({
											data: {
												is_page: 0,
												source: "quality",
												template_id: this.template_id
											}
										}).then(res => {
											i.list = res.data.list
											i.value = e
										})
									} else if (res.data.list.goods_select == 3) {
										getMaterialSelect({
											data: {
												is_page: 0,
												source: "quality",
												template_id: this.template_id
											}
										}).then(res => {
											i.list = res.data.list
											i.value = e
											this.$forceUpdate();
										})
									} else if (res.data.list.goods_select == 2) {

										qualityGoodsSelect({
											data: {
												is_page: 0,
												template_id: this.template_id
											}
										}).then(res => {
											i.list = res.data.list
											i.value = e
											this.$forceUpdate();
										})
									}

								}
							})
						})

					}

				})



			},
			seve() {
				this.table_list.forEach(item => {
					item.forEach(i => {
						if (i.fun) {
							i.fun = i.fun.toString()
						}
						if (i.field == "temperature" || i.field == "line_id" || i.field ==
							"goods_name" || i.field == "factory_id") {
							i.list = []
						}
						// if (i.field == "uid" &&i.value && i.type == "label" ) {
						// 	i.value = '检验员： ' 
						// }
						// if (i.field == "uid" && i.type == "label" ) {
						// 	i.value = ''
						// }
						if (i.type == 'table') {
							if (i.is_add && i.is_add.rawData) {
								i.is_add.rawData.forEach(d => {
									if (d.fun) {
										d.fun = d.fun.toString()
									}
								})

							}
							if (i.is_add && i.is_add.fun) {
								i.is_add.fun = i.is_add.fun.toString()
							}
							i.table_list.forEach(v => {
								v.forEach(d => {
									if (d.fun) {
										d.fun = d.fun.toString()
									}
								})

							})
						}
					})
				})

				saveTemplate({
					data: {
						"title": this.title, //名称
						"width": this.width, //宽度
						template_field: this.table_list,
						id: this.template_id
					}
				}).then(res => {
					this.getQualityRecordDetail()

				})
			},
			back() {
				this.$router.back()
				this.modal2Visible = false;
			},
			getQualityRecordDetail() {
				getQualityRecordDetail({
					data: {
						"type": this.type, //类型 1模板 2详情
						"id": this.id, //记录id 类型2时传
						"template_id": this.template_id //模板id 类型1时传
					},
					loading: true
				}).then(res => {
					this.id = res.data.list.id
					this.title = res.data.list.template_title
					//新增的时候用template_title
					// 详情看title
					this.table_list = res.data.list.template_field
					this.template_id = res.data.list.template_id
					this.width = res.data.list.width > 0 ? res.data.list.width : 960
					this.is_limit = res.data.list.is_limit
					if (this.type == 1) {
						this.table_list.forEach(item => {
							item.forEach(i => {
								if (i.fun) {
									i.fun = new Function('return ' + i.fun)();
								}
								if (i.type == 'table') {
									i.table_list.forEach(v => {
										v.forEach(d => {
											if (d.fun) {
												d.fun = new Function('return ' +
													d
													.fun)();
											}
										})
									})
									if (i.is_add && i.is_add.rawData) {
										i.is_add.rawData.forEach(d => {
											if (d.fun) {
												d.fun = new Function('return ' + d.fun)
													();
											}
										})
									}

									if (i.is_add && i.is_add.fun) {
										i.is_add.fun = new Function('return ' + i.is_add.fun)();
									}

								}
								if (i.field == "factory_id" && i.type == "select") {
									getFactorySelect({
										data: {
											"type": "other" //类型 search搜索 other其它
										}
									}).then(res => {
										i.list = res.data.list
									})
								}
								if (i.field == "inspection_time" && i.type == "time") {
									i.value = i.value ? i.value : moment().format(
										'YYYY-MM-DD HH:mm')
								}
								if (i.field == "inspection_time" && i.type == "range_time") {
									i.value = i.value ? i.value.split('-') : null
								}
								if (i.field == "product_batch_time" && i.type == "range_time") {
									i.value = i.value ? i.value.split('-') : null
								}
								if (i.field == "uid" && i.type == "label" && (i.value ==
										"检验员： " ||
										i.value == "检验员：")) {
									i.value = '检验员： ' + res.data.user.username
								}
								if (i.field == "uid" && i.type == "label" && i.value == "") {
									i.value = res.data.user.username
								}

								if (i.field == "line_id" && i.type == "select") {
									getLineSelect({
										data: {
											is_page: 0,
											template_id: this.template_id
										}
									}).then(res => {
										i.list = res.data.list
									})
								}
								if (i.field == "temperature" && i.type == "select") {
									getDensitySelect({
										data: {
											is_page: 0,
											source: "quality",
											template_id: this.template_id
										}
									}).then(res => {
										i.list = res.data.list
									})
								}
								if (i.field == "goods_name" && i.type == "select") {

									if (res.data.list.goods_select == 1) {
										getGoodsSelect({
											data: {
												is_page: 0,
												source: "quality",
												template_id: this.template_id
											}
										}).then(res => {
											i.list = res.data.list
										})
									} else if (res.data.list.goods_select == 3) {
										getMaterialSelect({
											data: {
												is_page: 0,
												source: "quality",
												template_id: this.template_id
											}
										}).then(res => {
											i.list = res.data.list
											this.$forceUpdate();
										})
									} else if (res.data.list.goods_select == 2) {
										qualityGoodsSelect({
											data: {
												is_page: 0,
												template_id: this.template_id
											}
										}).then(res => {
											i.list = res.data.list
											res.data.list.forEach(item => {
												if (item.value == i.value) {
													this.add_flag = item
														.capacity_unit
												}
											})

											this.$forceUpdate();
										})
									}
								}
							})
						})
						this.$nextTick(() => {
							this.$refs.ExcelVues.changeStyle(this.table_list)
						})
						this.getScaleFun()
					}else{
						
						this.new_title=res.data.list.title
					}
				})
			},
			// 将表单中数值整合到表格数据中
			mergeFormDataWithTable(form) {
				let arr = this.table_list
				let fun = (list, filed) => {
					list.forEach((row, index) => {
						row.forEach((data, da_index) => {
							if (data.type == 'input') {
								data.value = form[`${filed}_input_${index}_${da_index}`]
							} else if (data.type == 'number') {
								data.value = form[`${filed}_input_number_${index}_${da_index}`]
							} else if (data.type == 'textarea') {
								data.value = form[`${filed}_textarea_${index}_${da_index}`]
							} else if (data.type == 'time') {
								data.value = form[`${filed}_time_${index}_${da_index}`]
							} else if (data.type == 'range_time') {
								data.value = form[`${filed}_range_time_${index}_${da_index}`] ? form[
									`${filed}_range_time_${index}_${da_index}`].join(
									'-') : ''
							} else if (data.type == 'radio') {
								data.value = form[`${filed}_radio_${index}_${da_index}`]
							} else if (data.type == 'radio2') {
								data.value = form[`${filed}_radio_${index}_${da_index}`]
							} else if (data.type == 'select') {
								data.value = form[`${filed}_select_${index}_${da_index}`]
							} else if (data.type == 'disInput') {
								data.value = form[`${filed}_disInput_${index}_${da_index}`]
							}
						})

					});
				}
				arr.forEach((row, index) => {
					row.forEach((data, da_index) => {
						if (data.type == 'input') {
							data.value = form[`_input_${index}_${da_index}`]
						} else if (data.type == 'number') {
							data.value = form[`_input_number_${index}_${da_index}`]
						} else if (data.type == 'textarea') {
							data.value = form[`_textarea_${index}_${da_index}`]
						} else if (data.type == 'time') {
							data.value = form[`_time_${index}_${da_index}`]
						} else if (data.type == 'range_time') {
							data.value = form[`_range_time_${index}_${da_index}`] ? form[
								`_range_time_${index}_${da_index}`].join('-') : ''
						} else if (data.type == 'select') {
							data.value = form[`_select_${index}_${da_index}`]
						} else if (data.type == 'radio') {
							data.value = form[`_radio_${index}_${da_index}`]
						} else if (data.type == 'radio2') {
							data.value = form[`_radio_${index}_${da_index}`]
						} else if (data.type == 'table') {
							fun(data.table_list, `table${da_index}${index}`)
						} else if (data.type == 'disInput') {
							data.value = form[`_disInput_${index}_${da_index}`]
						}
					})

				});
				return arr
			},

			handleSave() {

				let _form = this.form.getForm()
				let _form_data = _form.getFieldsValue()
				let arr = this.mergeFormDataWithTable(_form_data)
				let obj = {
					"type": 1, //类型 1模板 2详情
					"id": this.id, //记录id 类型2时传

					template_field: [],
					"template_id": this.template_id //模板id 类型1时传
				}

				arr.forEach(item => {
					item.forEach(i => {
						if (i.fun) {
							i.fun = i.fun.toString()
						}
						if (i.type == 'table') {
							if (i.is_add && i.is_add.rawData) {
								i.is_add.rawData.forEach(d => {
									if (d.fun) {
										d.fun = d.fun.toString()
									}
								})
							}
							if (i.is_add && i.is_add.fun) {
								i.is_add.fun = i.is_add.fun.toString()
							}
							i.table_list.forEach(v => {
								v.forEach(d => {
									if (d.fun) {
										d.fun = d.fun.toString()
									}
								})

							})
						}
						if (i.field == "factory_id" && i.type == "select") {

							obj.factory_id = i.value
						}
						if (i.field == "goods_name" && i.type == "select") {
							obj.goods_id = i.value
						}
						if (i.field == "inspection_time" && i.type == "range_time") {

							obj.inspection_time = i.value
						}
						if (i.field == "inspection_time" && i.type == "time") {
							obj.inspection_time = i.value
						}
						if (i.field == "product_batch_time" && i.type == "range_time") {
							obj.product_batch_time = i.value
						}


						if (i.field == "shift" && i.type ==
							"select") {
							obj.shift = i.value
						}

						if (i.field == "product_batch_n" && i.type ==
							"input") {
							obj.product_batch_n = i.value
						}
					})

				})


				if (!obj.inspection_time) {
					this.$message.error('请填写抽检时间！');
					return false
				}
				if (!obj.goods_id) {
					this.$message.error('请选择品项规格！');
					return false
				}
				if (!obj.shift && obj.shift) {
					this.$message.error('请选择班次！');
					return false
				}
				if (!obj.factory_id) {
					this.$message.error('请选择工厂！');
					return false
				}

				this.loading = true
				obj.template_field = arr
				setTimeout(() => {
					saveQualityRecord({
						data: {
							...obj
						}
					}).then(res => {
						this.loading = false
						if (res.data.code == 1001) {
							this.tips = res.data.info
							this.modal2Visible = true
						} else {
							this.$message.success('表格暂存成功！');
							this.back()
						}
					})
				}, 300)

				setTimeout(() => {
					this.loading = false
				}, 3000)


			},
			// 正确实现表单提交和校验方法
			handleSubmit(e) {
				e.preventDefault(); // 阻止默认提交行为

				// 使用 Ant Design Vue 的表单校验
				this.form.validateFields((err, values) => {
					if (!err) {
						// 校验通过
						let arr = this.mergeFormDataWithTable(values)
						let obj = {
							"type": 2,
							"id": this.id, //记录id 类型2时传
							template_field: arr,
							"template_id": this.template_id //模板id 类型1时传
						}
						arr.forEach(item => {
							item.forEach(i => {
								if (i.field == "factory_id" && i.type == "select") {
									obj.factory_id = i.value
								}

								if (i.field == "product_batch_time" && i.type == "range_time") {
									obj.product_batch_time = i.value
								}
								if (i.field == "inspection_time" && (i.type == "time" || i
										.type ==
										"range_time")) {
									obj.inspection_time = i.value
								}
								if (i.field == "goods_name" && i.type ==
									"select") {
									obj.goods_id = i.value
								}
								if (i.field == "shift" && i.type ==
									"select") {
									obj.shift = i.value
								}

							})

						})
						this.loading2 = true
						setTimeout(() => {
							saveQualityRecord({
								data: {
									...obj
								}
							}).then(res => {
								this.loading2 = false
								this.$message.success('表单提交成功');
								this.back()
							})

						}, 500)


						setTimeout(() => {
							this.loading2 = false
						}, 3000)

					} else {
						// 校验失败
						this.$message.error('请检查表单填写是否正确');
					}
				});
			},
			// 获取当前屏幕的宽度计算表格的缩放值
			getScaleFun() {
				this.$nextTick(() => {
					const element = document.querySelector('.print_3G_Je');
					const print_contents = document.querySelector('.print_contents');

					const resizeObserver = new ResizeObserver(entries => {
						if (entries[0]) {
							let width = element.clientWidth;
							// let scale = Math.min(width / this.width, 1);
							if (this.width < width) {
								document.querySelector('.table_AgKOv').style.width = 'fit-content';
								document.querySelectorAll('table').forEach(item => {
									item.style.width = 'fit-content';
								})
								return
							}
							let scale = Math.min(width / this.width, 1);
							// 设置变换原点为顶部中心，这样缩放时元素从顶部水平居中
							print_contents.style.transformOrigin = 'top center';

							// 应用缩放变换
							print_contents.style.transform = `scale(${scale})`;

							// 确保内容在缩放后保持居中
							print_contents.style.left = '50%';
							print_contents.style.transform = `translate(-50%,0) scale(${scale})`;
							print_contents.style.transformOrigin = 'top center';

							// 计算缩放后的真实高度并设置容器
							const originalHeight = print_contents.scrollHeight;
							const scaledHeight = originalHeight * scale;

							// 设置外部容器高度
							element.style.height = `${scaledHeight}px`;
							// element.style.overflow = 'hidden';

							console.log(`width: ${width}, Scale: ${scale}`);
						}
					});
					resizeObserver.observe(element);
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.parser {
		position: relative;
	}

	td {
		font-size: 16px;
	}

	.print_box {
		background-color: #fff;
		min-height: 100vh;
		padding-top: 32px;
		padding-bottom: 32px;
	}

	.formBox {
		padding: 40px;
		background-color: #fff;
		margin: 15px 15px 0;
		width: calc(100% - 30px);
		min-height: calc(100% - 15px);
	}

	.content {
		min-width: fit-content;
		width: fit-content;
		background-color: #fff;
		box-shadow: 0 0 10px rgba(0, 0, 0, .15);
		// margin: 0 auto;
		position: relative;
		left: 50%;
		top: 0;
		transform: translate(-50%, 0);
	}

	.print_3G_Je {
		background-color: #fff;
		// overflow-x: auto;
		// overflow-y: hidden;
		// overflow-x: hidden;
		position: relative;
		width: 100%;
	}

	.printWraper_1kuG2 {
		// max-width: 962px;
		// max-width: 1202px;
		padding: 30px;
		margin: 0 auto;
		position: relative;
		z-index: 4;
		box-sizing: content-box;
		padding-top: 0;
	}

	.wraper_3ul6r {
		position: relative;
		display: flex;
		align-items: center;
	}

	.logo_3RbqF {
		max-width: 200px;
		max-height: 80px;
		margin-right: 16px;
	}

	.name_Ur6xR {
		font-size: 22px;
	}

	.title_3Yf8c {
		margin: 0 auto;
		padding: 0 0 20px;
		text-align: center;
		color: #1c2438;
		font-weight: 700;
		font-size: 28px;
	}

	h4 {
		margin-bottom: 16px;
	}

	.printBorder_3MGfU {
		width: 100%;
		margin: 0 auto;
		// border-top: 2px solid #43464d;
		border-bottom: 0px solid #495060;
	}

	.submit_btn_box {
		width: 100%;
		text-align: center;
		padding-bottom: 14px;

		.btn:nth-child(1) {
			margin-right: 24px;
		}

		.btn:nth-child(2) {
			margin-right: 24px;
		}

		.btn:nth-child(4) {
			margin-left: 24px;
		}
	}
</style>